const root = 'CreateStoreModal'
const form = `${root}-CreateStoreForm`
const platformRoot = 'createStoreModal'

export const TestId = {
  root,
  title: `${root}-title`,
  titleCloseButton: `${root}-title-closeButton`,
  form,
  storeName: `${form}-storeName`,
  integrationTypeRadioGroup: `${platformRoot}_integrationTypeRadioGroup`,
  platformTileWix: `${platformRoot}_platformTileWix`,
  platformTileShopify: `${platformRoot}_platformTileShopify`,
  platformTileOther: `${platformRoot}_platformTileOther`,
  countrySelect: `${platformRoot}_countrySelect`,
  nextButton: `${root}-nextButton`,
}
